// extracted by mini-css-extract-plugin
export default {"basicInfo":"styles_basicInfo__TNjQm"};